<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
export default {
  name: "app",
  created() {
    
    if (localStorage.eleTokenCustCysd001) {
      const decode = jwt_decode(localStorage.eleTokenCustCysd001);
      this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
      this.$store.dispatch("setUser", decode);
    }
  },
  methods: {
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    },
    //设置cookie
    setCookie(c_name, c_id, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "stuName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      if (c_id) {
        window.document.cookie =
          "stuId" + "=" + c_id + ";path=/;expires=" + exdate.toGMTString();
      }
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "stuName") {
            this.loginUser.password = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "stuId") {
            this.loginUser.identificationcard = arr2[1];
            this.checked = true;
          }
        }
      }
    },
  }
};
</script>


<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
}
.el-scrollbar {
    > .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
</style>
